/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/forbid-prop-types */
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import isEqual from 'lodash/isEqual';
import CategoryWrapperTransactions from './CategoryWrapperTransactions';

const utc = require('dayjs/plugin/utc');

dayjs.extend(utc);

// this is a HOC which does not add anything to the UI
// it's purpose is to prepare TRANSACTION data which are to be shown in the table
export function TransactionsWrapper({
  displayedComponent,
  account,
  setAccount,
  tableState,
  setTableState,
  displayedData,
  handleClick,
  userChangesPresent,
  setUserChangesPresent,
  highlightTransactionId,
  filter,
  connectedAccounts,
  handleNavigateToAccount,
}) {
  const commonProps = {
    account,
    setAccount,
    tableState,
    setTableState,
    displayedData,
    handleClick,
    userChangesPresent,
    setUserChangesPresent,
    connectedAccounts,
    handleNavigateToAccount,
  };

  if (displayedComponent === 'table') {
    return <CategoryWrapperTransactions {...commonProps} displayedComponent="table" highlightTransactionId={highlightTransactionId} filter={filter} />;
  }
  if (displayedComponent === 'grid') {
    return <CategoryWrapperTransactions {...commonProps} displayedComponent="grid" />;
  }
  return null;
}
TransactionsWrapper.propTypes = {
  displayedComponent: PropTypes.string.isRequired,
  account: PropTypes.object.isRequired,
  setAccount: PropTypes.func.isRequired,
  tableState: PropTypes.object.isRequired,
  setTableState: PropTypes.func.isRequired,
  displayedData: PropTypes.string.isRequired,
  handleClick: PropTypes.func.isRequired,
  userChangesPresent: PropTypes.bool.isRequired,
  setUserChangesPresent: PropTypes.func.isRequired,
  highlightTransactionId: PropTypes.string,
  filter: PropTypes.func,
  connectedAccounts: PropTypes.arrayOf(PropTypes.object),
  handleNavigateToAccount: PropTypes.func,
};
TransactionsWrapper.defaultProps = {
  highlightTransactionId: null,
  filter: null,
  connectedAccounts: [],
  handleNavigateToAccount: null,
};

// we are trying to stop redundant re-renders based on account prop allegedly changing
export const MemoizedTransactionsWrapper = memo(TransactionsWrapper, isEqual);
export default MemoizedTransactionsWrapper;
